<template>
  <dd-multi-select-wrapper
    :filter-query-key="filterQueryKey"
    :options="options"
    :title="title"
    :value="value"
    @input="$emit('input', $event)"
    @reset="$emit('reset', $event)"
  >
    <template #default="{ canRender, inputValue, onChange, onConfirm, onHide, onReset, options, title }">
      <!-- To shorten page load time in slower devices,
           only render multi-select filters
           after first user click -->
      <i-filter-select
        v-if="canRender"
        class="dd-selector__select--desktop"
        :options="options"
        :value="inputValue"
        @input="onChange"
        @confirm="onConfirm"
        @reset="onReset"
      />
    </template>
  </dd-multi-select-wrapper>
</template>

<script>
import FilterSelectInput from '../search/dropdown/filterSelectInput'
import MultiSelectDropdownWrapper from '../search/wrapper/multiSelectDropdownWrapper'

export default {
  components: {
    'dd-multi-select-wrapper': MultiSelectDropdownWrapper,
    'i-filter-select': FilterSelectInput,
  },
  props: {
    /**
     * filter query key
     */
    filterQueryKey: {
      default: '',
      type: String,
    },
    /**
     * all selection options
     */
    options: {
      default: () => [],
      type: Array,
    },
    /**
     * title
     */
    title: {
      default: '',
      type: String,
    },
    /**
     * value
     */
    value: {
      default: () => [],
      type: Array,
    },
  },
}
</script>

<style lang="postcss" scoped>
@screen mobile {
  .dd-selector {
    /* Hide desktop filter in mobile */
    & .dd-selector__select--desktop {
      @apply hidden;
    }
  }
}

@screen desktop {
  .dd-selector {
    & .dd-selector__select--desktop {
      @apply absolute h-auto z-20 left-0;
      top: 56px;
      width: 296px;
      max-height: 60vh;
      max-height: min(60vh, 680px);
      transition:
        transform 0.3s ease,
        opacity 0.3s ease;
    }
  }
  /* Hidden desktop filter */
  .dd-selector:not(.dd-selector--show) {
    & .dd-selector__select--desktop {
      @apply opacity-0 pointer-events-none;
      transform: translateY(-1.25rem);
    }
  }
}
</style>
